import { injectSaga, reloadSaga } from "redux-sagas-injector";
import { createSharedStore } from "@p81-common/shell-core-js";
import rootSaga from "./rootSaga";
import rootReducer from "./rootReducer";
import servicesPostSaga from "./api/organization/servicesPost/servicesPostSaga";
import addressesPostSaga from "./api/organization/addressesPost/addressesPostSaga";
import customUrlsPostSaga from "./api/organization/customUrlsPost/customUrlsPostSaga";
import customUrlsPutSaga from "./api/organization/customUrlsPut/customUrlsPutSaga";
import policyInsightsConflictAckPatchSaga from "./api/organization/policyInsightsConflictAckPatch/policyInsightsConflictAckPatchSaga";
import addressesGetSaga from "./api/organization/addressesGet/addressesGetSaga";
import servicesGetSaga from "./api/organization/servicesGet/servicesGetSaga";
import ipsecVendorsGetSaga from "./api/organization/ipsecVendorsGet/ipsecVendorsGetSaga";
import policyInsightsConflictsGetSaga from "./api/organization/policyInsightsConflictsGet/policyInsightsConflictsGetSaga";

const store = createSharedStore({ rootReducer, rootSaga });

// Global like the rootSaga.js forks, but registered by key: the Internet Access
// MFE (registerStore.ts) injectSaga's these same keys into this store, and
// injectSaga dedupes by key only. A fork() here plus the MFE's copy means two
// takeEvery watchers, so every dispatch hits the backend twice (P81-149541:
// duplicate created objects, and duplicate list GETs where the MFE's
// addresses/services copy could land last without `references`). Keys must
// stay identical to the MFE's.
//
// `deferred` reads the saga binding only when the key actually starts, like
// the old fork() did. Another federation container can re-evaluate this module
// (createSharedStore then returns the existing store and nothing starts) while
// one of these saga modules is still mid-evaluation; reading it directly there
// throws a TDZ ReferenceError in the webpack build.
const deferred = (getSaga) =>
  function* () {
    yield* getSaga()();
  };

injectSaga(
  "servicesPostSaga",
  deferred(() => servicesPostSaga),
  false,
  store
);
injectSaga(
  "addressesPostSaga",
  deferred(() => addressesPostSaga),
  false,
  store
);
injectSaga(
  "customUrlsPostSaga",
  deferred(() => customUrlsPostSaga),
  false,
  store
);
injectSaga(
  "customUrlsPutSaga",
  deferred(() => customUrlsPutSaga),
  false,
  store
);
injectSaga(
  "policyInsightsConflictAckPatchSaga",
  deferred(() => policyInsightsConflictAckPatchSaga),
  false,
  store
);
injectSaga(
  "addressesGetSaga",
  deferred(() => addressesGetSaga),
  false,
  store
);
injectSaga(
  "servicesGetSaga",
  deferred(() => servicesGetSaga),
  false,
  store
);
injectSaga(
  "ipsecVendorsGetSaga",
  deferred(() => ipsecVendorsGetSaga),
  false,
  store
);
injectSaga(
  "policyInsightsConflictsGetSaga",
  deferred(() => policyInsightsConflictsGetSaga),
  false,
  store
);

export default store;

if (module.hot) {
  module.hot.accept("./rootSaga", () => {
    reloadSaga("rootSaga", require("./rootSaga").default);
  });
}
